<template>
  <div v-if="loadOk">
    <b-card>
      <div slot="header">
        <strong>User ในบริษัท</strong>
      </div>
      <h5>เพิ่มผู้ใช้งาน</h5>
      <b-row>
        <b-col sm="12" md="4">
          <TextInput
            :value="$v.newUserData.name"
            id="new-name"
            feedback="ใส่ชื่อ"
            label="ชื่อ"
            placeholder="ตัวอย่าง: ชื่อ"
          />
        </b-col>
        <b-col sm="12" md="4">
          <TextInput
            :value="$v.newUserData.email"
            id="new-email"
            feedback="ใส่อีเมล"
            label="อีเมล"
            placeholder="ตัวอย่าง: test@logisty.asia"
          />
        </b-col>
        <b-col sm="12" md="4">
          <TextInput
            :value="$v.newUserData.phoneNumber"
            id="new-phoneNumber"
            feedback="ใส่เบอร์โทร"
            label="เบอร์โทร"
            placeholder="ตัวอย่าง: 0991234567"
          />
        </b-col>
        <b-col sm="12" md="4">
          <TextInput
            :value="$v.newUserData.password"
            id="new-password"
            feedback="ใส่รหัสผ่าน"
            label="รหัสผ่าน"
            placeholder="ตัวอย่าง: รหัสผ่าน 6 ตัวขึ้นไป"
          />
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-4">
        <b-col>
          <b-button size="sm" variant="primary" @click="addNew">เพิ่ม</b-button>
        </b-col>
      </b-row>

      <h5>รายชื่อ</h5>
      <b-table :items="operators" :fields="tableOperFields" striped responsive="sm">
        <template
          slot="createdAt"
          slot-scope="row"
        >{{ row.item.createdAt ? $moment(row.item.createdAt).format('LLL') : '' }}</template>

        <template slot="action" slot-scope="row">
          <b-button
            size="sm"
            @click="row.toggleDetails"
            class="mr-2"
          >{{ row.detailsShowing ? 'ซ่อน' : 'แสดง'}} แก้ไข</b-button>
          <b-button size="sm" variant="danger" @click="deleteUser(row.item._id)">ลบ</b-button>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-card>
            <h6>ข้อมูลทั่วไป</h6>
            <b-row class="my-1">
              <b-col sm="12" md="4">
                <label :for="row.item._id + '-name'">ชื่อ :</label>
                <b-form-input
                  :id="row.item._id+ '-name'"
                  v-model="editUserDatas[row.item._id].name"
                  :state="editUserValidator[row.item._id].name"
                  @input="validateEditUser(row.item._id)"
                ></b-form-input>
              </b-col>
              <b-col sm="12" md="4">
                <label :for="row.item._id+ '-email'">อีเมล :</label>
                <b-form-input
                  :id="row.item._id+ '-email'"
                  v-model="editUserDatas[row.item._id].email"
                  :state="editUserValidator[row.item._id].email"
                  @input="validateEditUser(row.item._id)"
                ></b-form-input>
              </b-col>
              <b-col sm="12" md="4">
                <label for="row.item._id+ '-phoneNumber'">เบอร์โทร (มือถือ) :</label>
                <b-form-input
                  :id="row.item._id+ '-phoneNumber'"
                  v-model="editUserDatas[row.item._id].phoneNumber"
                  :state="editUserValidator[row.item._id].phoneNumber"
                  @input="validateEditUser(row.item._id)"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-4">
              <b-col>
                <b-button size="sm" variant="primary" @click="editUser(row.item._id)">แก้ไข</b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <h6>ย้ายบริษัท</h6>
            <b-row class="my-1">
              <b-col md="6">
                <label for="row.item._id+ '-change-company'">เลือกบริษัทเป้าหมาย</label>
                <b-form-select v-model="editUserDatas[row.item._id].targetCompanyRefId" class="mb-3" :state="editUserValidator[row.item._id].targetCompanyRefId" @change="validateCompanyTarget(row.item._id)">
                  <option v-for="option in editCompanyOption" :key="option._id" :value="option.cid">{{ option.cid + '--' + option.name }}</option>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-button size="sm" variant="primary" @click="changeUserCompany(row.item._id)">เปลี่ยนบริษัท</b-button>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import Company from '../../../services/http/Company'
import User from '../../../services/http/User'

import { validationMixin } from 'vuelidate'

import { required, requiredIf, email, helpers, url, numeric, decimal, between, minLength, maxLength } from 'vuelidate/lib/validators'

import TextInput from '../../../components/TextInput'
const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

export default {
  components: {
    TextInput
  },
  mixins: [validationMixin],
  props: [
    'operators',
    'companyRefId'
  ],
  validations: {
    newUserData: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      phoneNumber: {
        required,
        thPhoneNumber
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  data () {
    return {
      loadOk: false,
      tableOperFields: [
        { key: 'name', label: 'ชื่อ-นามสกุล', class: 'text-center' },
        { key: 'email', label: 'อีเมล', class: 'text-center' },
        { key: 'phoneNumber', label: 'เบอร์โทร', class: 'text-center' },
        { key: 'createdAt', label: 'สร้างเมื่อ', class: 'text-center' },
        { key: 'action', label: 'จัดการ', class: 'text-center' }
      ],
      newUserData: {
        name: null,
        email: null,
        phoneNumber: null,
        password: null
      },
      editUserDatas: {},
      editUserValidator: {},
      editCompanyOption: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // for (let i=0; i< this.operators.length; i++) {
      //   this.editUserDatas[this.operators[i]._id] = {
      //     name: this.operators[i].name,
      //     email: this.operators[i].email,
      //     phoneNumber: this.operators[i].phoneNumber
      //   }
      // }
      this.operators.forEach(x => {
        this.editUserValidator[x._id] = {
          name: null,
          email: null,
          phoneNumber: null,
          targetCompanyRefId: null
        }
        this.editUserDatas[x._id] = {
          name: x.name,
          email: x.email,
          phoneNumber: x.phoneNumber,
          changeCompanyEmail: x.email,
          targetCompanyRefId: null
        }
      })

      let company = new Company()
      let companies = await company.getCompanyProfileAll()
      this.editCompanyOption = companies.data

      this.loadOk = true
    },
    async addNew () {
      this.$v.newUserData.$touch()
      if (this.$v.newUserData.$anyError) {
        return
      }

      let data = {
        email: this.newUserData.email,
        phoneNumber: this.newUserData.phoneNumber,
        companyRefId: this.companyRefId,
        name: this.newUserData.name,
        password: this.newUserData.password
      }

      let user = new User()
      try {
        let created = await user.addNewUser(data)
        if (created.code === 1) {
          alert('เพิ่มผู้ใช้งานแล้ว')
          Window.Event.$emit('childCompleteProcess')
          this.newUserData.name = null
          this.newUserData.email = null
          this.newUserData.phoneNumber = null
          this.newUserData.password = null
          this.$v.newUserData.$reset()
        } else {
          alert(created.message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async deleteUser (userId) {
      if (!confirm('ยืนยันลบ')) {
        return
      }
      let data = {
        userId: userId
      }
      let user = new User()
      try {
        let deleted = await user.deleteUser(data)
        if (deleted.code === 1) {
          alert('ลบแล้ว')
          Window.Event.$emit('childCompleteProcess')
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        console.log(error)
      }
    },
    async editUser (userId) {
      if (!this.editUserValidator[userId].name || !this.editUserValidator[userId].email || !this.editUserValidator[userId].phoneNumber) {
        return
      }

      let data = {
        userId: userId,
        name: this.editUserDatas[userId].name,
        email: this.editUserDatas[userId].email,
        phoneNumber: this.editUserDatas[userId].phoneNumber
      }

      let user = new User()

      try {
        let updated = await user.updateUser(data)
        if (updated.code === 1) {
          alert('บันทึกแล้ว')
          Window.Event.$emit('childCompleteProcess')
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        console.log(error)
      }
    },
    isEmail (email) {
      var re = /\S+@\S+\.\S+/
      return re.test(email)
    },
    isThPhoneNumber (input) {
      var re = /^\d{10}$/
      return re.test(input)
    },
    async changeUserCompany (userId) {
      if (!this.editUserValidator[userId].targetCompanyRefId) {
        return
      }

      let user = new User()

      let data = {
        email: this.editUserDatas[userId].changeCompanyEmail,
        companyRefId: this.editUserDatas[userId].targetCompanyRefId
      }

      try {
        let updated = await user.updateUserCompany(data)
        if (updated.code === 1) {
          alert('เปลี่ยนบริษัทแล้ว')
          Window.Event.$emit('childCompleteProcess')
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        console.log(error)
      }
    },
    validateEditUser (userId) {
      if (this.editUserDatas[userId].name) {
        this.editUserValidator[userId].name = true
      } else {
        this.editUserValidator[userId].name = false
      }

      if (this.editUserDatas[userId].email && this.isEmail(this.editUserDatas[userId].email)) {
        this.editUserValidator[userId].email = true
      } else {
        this.editUserValidator[userId].email = false
      }

      if (this.editUserDatas[userId].phoneNumber && this.isThPhoneNumber(this.editUserDatas[userId].phoneNumber)) {
        this.editUserValidator[userId].phoneNumber = true
      } else {
        this.editUserValidator[userId].phoneNumber = false
      }

      this.$forceUpdate()
    },
    validateCompanyTarget (userId) {
      if (this.editUserDatas[userId].targetCompanyRefId) {
        this.editUserValidator[userId].targetCompanyRefId = true
      } else {
        this.editUserValidator[userId].targetCompanyRefId = false
      }

      this.$forceUpdate()
    }
  }
}
</script>
